/* eslint-disable import/prefer-default-export */

export const chain = (...reducers) => (state, action) =>
  reducers.reduce((prev, r) => r(prev, action), state);
